import { memo } from 'react';
import { StaticImageData } from 'next/image';
import classnames from 'classnames';

import styles from './VideoContainer.module.scss';

import VideoPlayer from '@/components/VideoPlayer/VideoPlayer';

export type Props = {
  className?: string;
  src: string;
  poster: { data: StaticImageData; alt?: string };
  bgImage: StaticImageData;
  isOdd: boolean;
};

function VideoContainer({ className, src, poster, isOdd }: Props) {
  return (
    <div className={classnames(styles.VideoContainer, className, { [styles.isEven]: !isOdd })}>
      <VideoPlayer src={src} poster={poster} loop className={styles.video} />
    </div>
  );
}

export default memo(VideoContainer);
